import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import DefaultEnterpriseSubNavigation from 'bundles/composable-page-header-enterprise/components/DefaultEnterpriseSubNavigation';
import { useEnterpriseMyPageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import LoggedInEnterpriseDesktopMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/desktop/LoggedInEnterpriseDesktopMainNav';
import LoggedOutEnterpriseDesktopMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/desktop/LoggedOutEnterpriseDesktopMainNav';
import LoggedInEnterpriseMobileMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/mobile/LoggedInEnterpriseMobileMainNav';
import LoggedOutEnterpriseMobileMainNav from 'bundles/composable-page-header-enterprise/main-nav-modules/mobile/LoggedOutEnterpriseMobileMainNav';
import DefaultEnterprisePageHeaderProvider from 'bundles/composable-page-header-enterprise/providers/DefaultEnterprisePageHeaderProvider';
import LegacyGDPRBannerWrapper from 'bundles/composable-page-header/banners/LegacyGDPRBannerWrapper';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import { DEFAULT_SUB_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';
import type { PageNavLink } from 'bundles/unified-common/hooks/useEnterprisePageHeaderLinks';

type Props = {
  subnavLinks?: PageNavLink[];
};

const EnterprisePageHeader = ({ subnavLinks }: Props) => {
  const { currentPageProgram } = useEnterpriseMyPageHeader();
  const user = userGet();

  if (!currentPageProgram) {
    return null;
  }
  const getDesktopNav = () => {
    if (user?.id) {
      return LoggedInEnterpriseDesktopMainNav;
    } else {
      return LoggedOutEnterpriseDesktopMainNav;
    }
  };
  const getMobileNav = () => {
    if (user?.id) {
      return <LoggedInEnterpriseMobileMainNav subnavLinks={subnavLinks} />;
    } else {
      return <LoggedOutEnterpriseMobileMainNav />;
    }
  };

  const DesktopNavComponent = getDesktopNav();
  const MobileNavComponent = getMobileNav();

  return (
    <GlobalPageHeaderContainer
      desktopMainNav={<DesktopNavComponent />}
      mobileMainNav={MobileNavComponent}
      subNav={<DefaultEnterpriseSubNavigation subnavLinks={subnavLinks} />}
      banners={[{ name: 'GDPRBanner', component: <LegacyGDPRBannerWrapper /> }]}
    />
  );
};

const EnterprisePageHeaderWithProvider = ({ subnavLinks }: Props) => {
  const subnavLinksExist = subnavLinks && subnavLinks.length > 0;

  return (
    <GlobalPageHeaderStateProvider
      additionalDefaultPageHeaderHeight={subnavLinksExist ? DEFAULT_SUB_NAV_HEIGHT : undefined}
    >
      <DefaultEnterprisePageHeaderProvider>
        <EnterprisePageHeader subnavLinks={subnavLinks} />
      </DefaultEnterprisePageHeaderProvider>
    </GlobalPageHeaderStateProvider>
  );
};

export default EnterprisePageHeaderWithProvider;
